var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-logo-whatsapp",
    "data-name": "Icon ionic-logo-whatsapp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.5,
    height: 31.5,
    viewBox: "0 0 31.5 31.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-logo-whatsapp-2",
    "data-name": "Icon ionic-logo-whatsapp",
    d: "M18.286,2.25A15.4,15.4,0,0,0,2.822,17.594a15.186,15.186,0,0,0,2.219,7.923L2.25,33.75l8.562-2.72A15.49,15.49,0,0,0,33.75,17.594,15.4,15.4,0,0,0,18.286,2.25Zm7.69,21.172a3.994,3.994,0,0,1-2.735,1.763c-.725.038-.746.562-4.7-1.156s-6.332-5.9-6.519-6.164a7.584,7.584,0,0,1-1.459-4.11,4.382,4.382,0,0,1,1.5-3.215,1.514,1.514,0,0,1,1.071-.451c.311-.005.513-.009.743,0s.576-.048.875.748,1.016,2.753,1.107,2.952a.716.716,0,0,1,.007.687,2.686,2.686,0,0,1-.419.639c-.206.221-.434.5-.618.664-.205.187-.42.392-.2.792a11.833,11.833,0,0,0,2.094,2.794,10.789,10.789,0,0,0,3.1,2.061c.388.211.619.188.86-.065s1.029-1.107,1.308-1.488.539-.307.9-.164,2.261,1.164,2.649,1.375.646.318.739.485A3.247,3.247,0,0,1,25.975,23.422Z",
    transform: "translate(-2.25 -2.25)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.2b6b76bf73edab4b0f8447a093b6c523.svg";
export { ForwardRef as ReactComponent };